import { useState, useEffect } from 'react';
import isEqual from 'react-fast-compare';

/**
 * Custom hook to track if form fields have been modified from their initial values
 * @param {Object} initialValues - The initial values to compare against
 * @param {Object} currentValues - The current values from form and state
 * @returns {boolean} isDirty - Whether any field has been modified
 */
const useFormDirtyState = (initialValues, currentValues) => {
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      console.log('🔍 useFormDirtyState: Initial values empty, setting isDirty to false');
      setIsDirty(false);
      return;
    }

    const hasChanges = !isEqual(initialValues, currentValues);

    setIsDirty(hasChanges);
  }, [initialValues, currentValues]);

  return isDirty;
};

export default useFormDirtyState;
